import Page from './colors.page'

let routes = [
  {
    path: 'colors',
    name: 'colors',
    component: Page
  }
]

export default routes
